import { useTranslation } from 'react-i18next';
import { Eye } from 'lucide-react';

/**
 * Banner discreto que se muestra permanentemente cuando el usuario está en
 * modo demo. Sirve de recordatorio antes de intentar cualquier acción;
 * cuando la acción falla por RLS, el toast global termina la conversación.
 */
export function DemoBanner() {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-center gap-1.5 border-b border-amber-200 bg-amber-50 px-3 py-1.5 text-[11px] text-amber-900">
      <Eye size={12} />
      <span className="font-semibold uppercase tracking-wider">
        {t('common.demo_readonly_banner')}
      </span>
    </div>
  );
}
